import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import logo from './Logo-Unified-smb.png'
import { getCountryName } from '../../utils';
import middleware from '../Api/Middleware';

// PDF Styles
const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        backgroundColor: '#FFFFFF',
        padding: 35,
        fontFamily: 'Helvetica',
    },
    logo: {
        maxWidth: 200,
        maxHeight: 120,
        marginBottom: 20,
    },
    header: {
        fontSize: 24,
        marginBottom: 20,
        fontWeight: 'bold',
        color: '#333333',
    },
    headerLabel: {
        fontWeight: 'bold',
        fontSize: 9,
        marginBottom: 2,
    },
    companyInfo: {
        position: 'absolute',
        top: 50,
        right: 30,
        width: 200,
        fontSize: 9,
        color: 'black',
        textAlign: 'right',
        alignItems: 'flex-end'
    },
    customerInfo: {
        marginBottom: 20,
        fontSize: 9,
    },
    tableHeader: {
        marginBottom: 20,
        textAlign: 'center',
        justifyContent: 'center',
    },
    tableSubHeader: {
        flexDirection: 'column',
    },
    subHeaderText: {
        fontSize: 9,
    },
    table: {
        display: 'table',
        width: 'auto',
        marginBottom: 20,
    },
    tableRowHeader: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: '#6AC1E7',
        paddingBottom: 5,
        marginBottom: 10,
    },
    tableRow: {
        flexDirection: 'row',
        paddingVertical: 1,
    },
    tableColHeader: {
        width: '25%',
        paddingHorizontal: 0,
        paddingVertical: 8,
        alignItems: 'flex-start',
    },
    tableCol: {
        paddingHorizontal: 0,
        paddingVertical: 8,
        alignItems: 'flex-start',
    },
    tableCellHeader: {
        fontSize: 10,
        fontWeight: 'bold',
        color: '#333333',
        textAlign: 'left',
    },
    tableCell: {
        fontSize: 9,
        color: '#333333',
        textAlign: 'left',
    },
    checkbox: {
        width: 12,
        height: 12,
        borderWidth: 1,
        borderColor: '#000000',
        borderStyle: 'solid',
        backgroundColor: '#FFFFFF',
    },
});

const PickPDFPages = ({ packingSlipData, companyInfo }) => {
    const order = packingSlipData.order;
    const customer = order.client_consumer ?? order.client_business;
    const company = companyInfo;
    const deliveryData = packingSlipData.delivery_address;
    const companyAddress = `${company.street_name || ''} ${company.house_number || ''}${company.addition ? ` - ${company.addition}` : ''}`.trim();
    const deliveryAddress = `${deliveryData?.streetname || ''} ${deliveryData?.housenumber || ''}${deliveryData?.addition ? ` - ${deliveryData?.addition}` : ''}`.trim();
    const companyLogo = company.logo ? `${middleware.defaults.imagesBaseURL}${company.logo}` : logo;

    return (
        <>
            <Page size="A4" style={styles.page}>
                {/* Company Info */}
                <View style={styles.companyInfo}>
                    <Text>{company.company_name}</Text>
                    <Text>{companyAddress}</Text>
                    <Text>{company.postal_code}, {company.city}</Text>
                    <Text> </Text>
                    <Text>{company.email}</Text>
                    <Text>{company.website}</Text>
                    <Text> </Text>
                    <Text>KVK: {company.cocnumber}</Text>
                    <Text>BTW: {company.vatnumber}</Text>
                    <Text>BANK: {company.iban}</Text>
                </View>

                {/* Header */}
                <View style={{ minHeight: 100 }}>
                    <Image src={companyLogo} style={styles.logo} />
                </View>

                {/* Customer Info */}
                <View style={styles.customerInfo}>
                    <Text style={styles.headerLabel}>Bezorgadres:</Text>
                    {!deliveryData ? (
                        <Text>Geen bezorgadres gevonden</Text>
                    ) : (
                        <>
                            {customer.company_name ? (
                                <Text>{customer.company_name}</Text>
                            ) : (
                                <Text>{customer.first_name} {customer.last_name}</Text>
                            )}
                            <Text>{deliveryAddress}</Text>
                            <Text>{deliveryData?.postalcode}, {deliveryData?.city}</Text>
                            <Text>{getCountryName(deliveryData?.country?.country_code_2)}</Text>
                        </>
                    )}
                </View>

                {/* Above table header */}
                <View style={styles.tableHeader}>
                    <View>
                        <Text style={styles.header}>PAKBON</Text>
                    </View>
                </View>

                {/* Between table and table header */}
                <View style={styles.tableSubHeader}>
                    <View>
                        <Text style={styles.subHeaderText}>Bestelnummer: {order.order_number}</Text>
                    </View>
                </View>

                {/* Products Table */}
                <View style={styles.table}>
                    {/* Table Header */}
                    <View style={styles.tableRowHeader}>
                        <View style={[styles.tableColHeader, { width: '15%' }]}>
                            <Text style={styles.tableCellHeader}>Aantal</Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '100%' }]}>
                            <Text style={styles.tableCellHeader}>Artiekelnummer</Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '52%' }]}>
                            <Text style={styles.tableCellHeader}>Omschrijving</Text>
                        </View>
                        <View style={[styles.tableColHeader, { width: '8%' }]}>
                            <Text style={styles.tableCellHeader}>✓</Text>
                        </View>
                    </View>

                    {/* Table Rows */}
                    {order.orders_sold_products.length > 0 ? (
                        order.orders_sold_products.map((item, index) => (
                            <View style={styles.tableRow} key={index}>
                                <View style={[styles.tableCol, { paddingLeft: 12, width: '15%' }]}>
                                    <Text style={styles.tableCell}>{item.amount}</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '100%', paddingRight: 2 }]}>
                                    <Text style={styles.tableCell}>{item.product_number}</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '52%' }]}>
                                    <Text style={styles.tableCell}>{item.product_name}</Text>
                                </View>
                                <View style={[styles.tableCol, { width: '8%' }]}>
                                    <View style={styles.checkbox}></View>
                                </View>
                            </View>
                        ))
                    ) : (
                        <View style={styles.tableRow}>
                            <View style={styles.tableCol}>
                                <Text style={styles.tableCell}>Geen producten gevonden</Text>
                            </View>
                        </View>
                    )}
                </View>
            </Page>
        </ >
    );
};

export default PickPDFPages;